import React from 'react';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';

const RawTextAreaInput = ({ name, ...otherInputProps }) => (
  <textarea
    name={name}
    id={name}
    type="text"
    className="input-large"
    {...otherInputProps} // You can override id, className, etc.
  />
);

RawTextAreaInput.displayName = 'RawTextAreaInput';

const RawTextAreaField = wrapFormComponentWithLabelAndError(RawTextAreaInput);
RawTextAreaField.displayName = 'RawTextAreaField';

export { RawTextAreaField };

const TextAreaField = connectFormComponentToReduxForm(RawTextAreaField);
TextAreaField.displayName = 'TextAreaField';

export default TextAreaField;

const TextAreaInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawTextAreaInput));
export { TextAreaInput };
